import React, { useState } from "react";
import {
  Select,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";

const { Option } = Select;

const TaskInput: React.FC<any> = ({ value, onChange, rowIndex, allProjects }) => {
  const [tasks, setTasks] = useState([]);
  const [values, setValues] = useState([]);
  const { projects } = useSelector((state: RootState) => state.auth);
  return (
    <Select
      showSearch
      className="w-full"
      placeholder={"Select task"}
      value={value?.tasks?.[0]?.id}
      onChange={(value) => {
        const results = tasks.find((x) => {
          return x.id === value;
        });
        onChange({
          type: "task-picker",
          tasks: [results],
        });
      }}
      filterOption={(input, option) =>
        (option!.children as unknown as string)
          .toLowerCase()
          .includes(input.toLowerCase())
      }
      onFocus={() => {
        const tasks = projects?.tasks?.[0]?.[0] || {};
        const selectedProject = projects?.projects.find((prj) => {
          return prj.id === allProjects?.current?.[rowIndex]?.project;
        });
        const selectedTaskId = Object.keys(tasks)?.find((taskId) => {
          return selectedProject?.taskId === taskId;
        });
        const projectSubTasks = tasks?.[selectedTaskId]?.subTasks ?? {};
        setTasks(
          Object.keys(projectSubTasks).map((subKey) => {
            return {
              id: subKey,
              ...projectSubTasks[subKey],
            };
          })
        );
        setValues([]);
      }}
    >
      {tasks?.map((task, index) => (
        <Option value={task.id}>{task.name}</Option>
      ))}
    </Select>
  );
};

export default TaskInput;
